import { render, staticRenderFns } from "./ComplianceMenu.vue?vue&type=template&id=2eeca56c&"
import script from "./ComplianceMenu.vue?vue&type=script&lang=js&"
export * from "./ComplianceMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports